import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { List } from "semantic-ui-react";
import { Link } from "react-router-dom";
import User from "~/models/User";
import "~/styles/tourbuzz/Footer.less";
import DomainNameUtils from "~/utils/DomainNameUtils";
import AuthenticatedUserHelper from "~/utils/AuthenticatedUserHelper";

const TourbuzzFooter = ({ user, t }) => {
  return (
    <div id="footer" className="footer-container">
      <div className="footer-content">
        {DomainNameUtils.isTourbuzz() || DomainNameUtils.isMyUrbanimmersive() ? (
          <>
            <div className="footer-primary-container">
              <div className="footer-support-links">
                <h3>{t("support")}</h3>
                <List>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="https://help.tourbuzz.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("supportSite")}
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="https://help.tourbuzz.com/category/398-faqs"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("frequentlyAskedQuestions")}
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="https://help.tourbuzz.com/category/271-tutorial-videos"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("tutorialVideos")}
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="http://status.tourbuzz.net"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("systemStatus")}
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="https://www.urbanimmersive.com/contact-us"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("contact")}
                    </a>
                  </List.Item>
                </List>
              </div>

              <div className="footer-connect-links">
                <h3>{t("connect")}</h3>
                <List>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="https://www.urbanimmersive.com/blog_list"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("blog")}
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="https://linkedin.com/company/urbanimmersive"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("linkedIn")}
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="https://www.facebook.com/urbanimmersiveSolutions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("facebook")}
                    </a>
                  </List.Item>
                  <List.Item>
                    <a className="footer-link-a" href="tel:1-877-246-9887" target="_blank" rel="noopener noreferrer">
                      1-877-246-9887
                    </a>
                  </List.Item>
                  <List.Item>
                    <a
                      className="footer-link-a"
                      href="mailto:hello@urbanimmersive.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      hello@urbanimmersive.com
                    </a>
                  </List.Item>
                </List>
              </div>
            </div>

            <div className="footer-secondary-container">
              <div className="footer-logo-content">
                {AuthenticatedUserHelper.isAuthenticatedCustomer(user) && DomainNameUtils.isClientPanel() ? (
                  <Link to="/tours">
                    <img src="/skins/tourbuzz/default/shared/img/new_tb_logo_white.png" alt="Tourbuzz Logo" />
                  </Link>
                ) : (
                  <img src="/skins/tourbuzz/default/shared/img/new_tb_logo_white.png" alt="Tourbuzz Logo" />
                )}
              </div>

              <div className="footer-aux-info">
                <div className="footer-copyright-wrap">
                  <p>
                    {t("copyright20062020")}{" "}
                    <a href="https://www.urbanimmersive.com" target="_blank" rel="noopener noreferrer">
                      Urbanimmersive Inc.
                    </a>
                  </p>
                </div>
                <div className="footer-rights-wrap">
                  <p>
                    {t("allRightsReserved")}{" "}
                    <a href="https://www.urbanimmersive.com/policy" target="_blank" rel="noopener noreferrer">
                      {t("privacyPolicy")}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {window.templateDefaults.footerLinks.map((footerLink, index) => (
              <div
                /* eslint-disable-next-line react/no-array-index-key */
                key={index}
                className="footer-custom-domain-container"
              >
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={footerLink.url}
                  className="footer-custom-domain-link"
                >
                  {footerLink.label}
                </a>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

TourbuzzFooter.propTypes = {
  user: PropTypes.instanceOf(User),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TourbuzzFooter);
